const getTemplate = (text, type, classes, dataAttribute) => {
    const buttonText = text || '[Ok]';
    const template = document.createElement('template');
    template.innerHTML = `
        <button data-button-primary ${dataAttribute} type="${type}" class="bk-button-primary ${classes}">${buttonText}</button>
    `;

    return template;
};

export default getTemplate;
